import ActiveCache from '@/cache.active';


class appController{
  constructor(
    $auth,
    $channel
  ){
    'ngInject';

    this.ActiveCache = new ActiveCache();

    this.isAuthenticated = $auth.isAuthenticated();
    this.grid = {
      box: 'col-box-border col-box-360 col-std-window',
      form: 'col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-std-window',
      list: 'col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-std-window',
      listElement: this.ActiveCache.cacheGet('app.grid.listElement') || 'col-xs-12 col-sm-6 col-list-element'
    };

    this.openedComponent = null;

    const defaultFormat = "YYYY-MM-DDTHH:mm:ss";

    window.moment.locale('pl');
    window.moment.defaultFormat = defaultFormat;
    window.moment.defaultFormatUtc = defaultFormat;

  }
}

export default appController;


/** WEBPACK FOOTER **
 ** ./frontend/app.controller.js
 **/